import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./styles/tailwind.css";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { useLogger } from "@/stores/useLogger";
import {buildErrorMeta} from "@/utils/error-handler"

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);

app.use(router).use(pinia);
const my_logger = useLogger();
my_logger.wireLifecycle();

app.config.errorHandler = (err, instance, info) => {
  const metadata = buildErrorMeta(err, instance, info);
  my_logger.log("upload_type_changed", { metadata });
  // here you could also send the error to a logging backend
};

app.mount("#app");
